// Global Instructions Rule Applied!

import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

// The compose form's Send type options and the state of the mailbox channel
// (capital call notices, stage 6a).
//
// GET /email/channels → view__email_channels.
//
// .strict() at every level: a key the model does not name is an error, not
// something to drop (CLAUDE.md).

/** One way a campaign can be sent (cfg.app_config email/channels). */
export const EmailChannelOptionSchema = z
  .object({
    // the email_campaigns.channel value
    code: z.string(),
    label: z.string(),
    description: z.string(),
    // false where this environment cannot send on the channel
    enabled: z.boolean(),
    // why not; null when enabled
    disabled_reason: z.string().nullable()
  })
  .strict()

export type EmailChannelOption = z.infer<typeof EmailChannelOptionSchema>

/** The mailbox channel here: switched on? which mailboxes may send? */
export const EmailMailboxChannelSchema = z
  .object({
    enabled: z.boolean(),
    // 'mock' (logs, sends nothing) | 'msgraph'
    provider_key: z.string(),
    // lower-cased mailboxes an admin enabled for campaign sends
    sender_emails: z.array(z.string())
  })
  .strict()

export const EmailChannelsSchema = z
  .object({
    channels: z.array(EmailChannelOptionSchema),
    mailbox: EmailMailboxChannelSchema
  })
  .strict()

export type EmailChannels = z.infer<typeof EmailChannelsSchema>

export function validateEmailChannels(data: unknown): EmailChannels {
  return validateWithZodSchema(EmailChannelsSchema, data, 'email channels')
}
